import {
  Box,
  Container,
  Heading,
  HStack,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FLIGHT_HERITAGE } from "../assets/Flight";
import { CapsuleIcon, StarshipIcon } from "./icons/VehicleIcons";
import SectionHeader from "./SectionHeader";

const MotionBox = motion(Box);

const ICONS = {
  starship: StarshipIcon,
  capsule: CapsuleIcon,
};

export default function FlightHeritage() {
  return (
    <Box id="flight" py={{ base: 20, md: 28 }}>
      <Container maxW="5xl" px={{ base: 6, md: 8 }}>
        <SectionHeader
          eyebrow="01 / Flight Heritage"
          title="Vehicles my work supports"
          description="Programs where my software and scheduling work has flown, or is flying, on real hardware."
        />

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 6, md: 8 }}>
          {FLIGHT_HERITAGE.map((program, index) => {
            const VehicleIcon = ICONS[program.icon];
            return (
              <MotionBox
                key={program.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                border="1px solid"
                borderColor="whiteAlpha.200"
                borderRadius="md"
                p={{ base: 6, md: 8 }}
                transitionProperty="border-color"
                transitionDuration="0.25s"
                _hover={{ borderColor: "whiteAlpha.400" }}
              >
                <HStack align="flex-start" spacing={6}>
                  <VehicleIcon
                    boxSize={{ base: "56px", md: "64px" }}
                    color="white"
                    opacity={0.9}
                    flexShrink={0}
                  />

                  <VStack align="flex-start" spacing={2} flex={1}>
                    <Heading
                      fontSize={{ base: "xl", md: "2xl" }}
                      fontWeight="500"
                      letterSpacing="-0.02em"
                      color="white"
                    >
                      {program.name}
                    </Heading>

                    <Link
                      href={program.orgUrl}
                      isExternal
                      fontSize="sm"
                      color="whiteAlpha.700"
                      _hover={{ color: "white", textDecoration: "none" }}
                    >
                      {program.org}
                    </Link>

                    <Text
                      fontFamily="mono"
                      fontSize="xs"
                      letterSpacing="0.1em"
                      textTransform="uppercase"
                      color="whiteAlpha.500"
                      border="1px solid"
                      borderColor="whiteAlpha.200"
                      borderRadius="full"
                      px={3}
                      py={1}
                      mt={1}
                    >
                      {program.status}
                    </Text>

                    <Text
                      color="whiteAlpha.700"
                      fontSize="sm"
                      lineHeight="1.7"
                      pt={2}
                    >
                      {program.description}
                    </Text>
                  </VStack>
                </HStack>
              </MotionBox>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
